/* Diamond Domain - builds and maintains the meta row (Sep 2026).

   THE ROW CONTAINS ONLY ELEMENTS WE CREATE. Nothing is moved into it.

   That is the lesson of four failed attempts. Moving the theme's own elements into the row
   brought their display, width and float rules with them, and no amount of !important on the
   container reliably beat that - two short phrases kept rendering on separate lines and the
   cause was never visible from the markup. Both values are now COPIED as text into spans this
   file owns, so the row is plain inline text and cannot stack.

   Sources, read with innerText rather than textContent:

   - The stock badge holds ALL FOUR states at once ("Item is in stock", "Hurry! Low
     inventory", "Item is out of stock", "Item is unavailable") and the theme reveals one by
     toggling a class on it. innerText returns only the rendered one. The badge is parked off
     screen by dd-pdp.js rather than hidden, because innerText returns nothing for a
     display:none element.

   - The diamond spec. A per-product value from custom.diamond_quality is preferred when one
     exists; otherwise the theme's site-wide default is used. Nothing has a value yet, so the
     default applies everywhere for now.

   The theme's state class (count-is-low, count-is-in, ...) is mirrored onto our span so
   dd-meta.css can colour it - amber for low, emerald for in stock.

   Runs on every replay, so it survives the theme re-rendering <variant-selects>.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  function tidy(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function run() {
    var col = document.querySelector('product-sticky.form__wrapper');
    if (!col) return false;

    var row = col.querySelector('.dd-meta');
    if (!row) return false;

    var stock = row.querySelector('.dd-stock');
    var spec = row.querySelector('.dd-spec');

    /* stock, with its live state */
    var cd = col.querySelector('[data-dd-stock-src]');
    if (cd && stock) {
      var txt = tidy(cd.innerText);

      stock.textContent = '';
      if (txt) {
        var dot = document.createElement('i');
        dot.className = 'dd-stock__dot';
        dot.setAttribute('aria-hidden', 'true');
        stock.appendChild(dot);
        stock.appendChild(document.createTextNode(txt));
      }

      stock.className = 'dd-stock';
      var state = (String(cd.className).match(/count-is-[a-z-]+/i) || [])[0];
      if (state) stock.classList.add('dd-' + state.toLowerCase());
    }

    /* the diamond spec: the product's own value if it has one, else the theme default */
    if (spec) {
      var own = document.getElementById('dd-quality');
      var src = col.querySelector('[data-dd-spec-src]');
      var s = '';

      if (own) s = tidy(own.textContent);
      else if (src) s = tidy(src.innerText);

      s = s.replace(/^diamond\s+quality\s*[-–—:]\s*/i, '');
      if (s && !/^Quality/i.test(s)) s = 'Quality ' + s;
      spec.textContent = s;
    }

    /* hide whatever came out empty, then mark the first survivor so dd-meta.css knows where
       NOT to draw a separator */
    var first = null;
    [].forEach.call(row.children, function (el) {
      el.classList.remove('dd-meta--first');

      if (tidy(el.textContent)) {
        el.style.removeProperty('display');
        if (!first) first = el;
      } else {
        el.style.setProperty('display', 'none', 'important');
      }
    });

    if (first) first.classList.add('dd-meta--first');
    return true;
  }

  (window.__ddInit = window.__ddInit || []).push(run);

  function start() {
    run();
    var tries = 0;
    var timer = setInterval(function () {
      run();
      if (++tries > 20) clearInterval(timer);
    }, 300);

    var form = document.querySelector('form.shopify-product-form');
    if (form) form.addEventListener('change', function () { setTimeout(run, 80); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();